/**
 * Google Calendar integration — calls backend OAuth2 endpoints.
 * All token management and Google API calls are handled server-side.
 */

import axios from 'axios';
import { pb } from './pocketbase';
import { installSessionRecovery } from './session';

const api = axios.create({ baseURL: '' });

api.interceptors.request.use((config) => {
  const token = pb.authStore.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

installSessionRecovery(api);

export async function getGoogleAuthUrl() {
  const { data } = await api.get('/api/google/auth-url');
  return data.url;
}

export async function exchangeGoogleCode(code) {
  const { data } = await api.post('/api/google/exchange', { code });
  return data;
}

export async function getGoogleStatus() {
  const { data } = await api.get('/api/google/status');
  return data.connected;
}

export async function disconnectGoogle() {
  const { data } = await api.post('/api/google/disconnect');
  return data;
}

/** Send the upcoming appointments that are not in Google Calendar yet. */
export async function pushGoogleEvents() {
  const { data } = await api.post('/api/google/push');
  return data;
}

export async function importGoogleEvents() {
  const { data } = await api.post('/api/google/import');
  return data;
}
